import { i18n as i18nType } from 'i18next'

import { Language } from '@/entities/common/Locale'

// eslint-disable-next-line @typescript-eslint/no-deprecated
import { z } from './zod'
import { makeZodI18nMap } from './zod-i18n'

const zodLocales = {
    de: z.locales.de,
    en: z.locales.en,
}

z.config({
    localeError: makeZodI18nMap({ ns: ['zod', 'custom'] }),
})

const cachedZodI18nMap: Record<string, z.core.$ZodErrorMap> = {}

export const changeI18nErrorMap = (i18n: i18nType) => {
    setZodLocale(i18n)

    z.config({
        localeError: makeZodI18nMap(i18n),
    })
}

export const getI18nErrorMap = (i18n: i18nType): z.core.$ZodErrorMap => {
    setZodLocale(i18n)

    if (!cachedZodI18nMap[i18n.language]) {
        cachedZodI18nMap[i18n.language] = makeZodI18nMap(i18n)
    }

    return cachedZodI18nMap[i18n.language]
}

const setZodLocale = (i18n: i18nType) => {
    const language = i18n.language?.split('-')[0]
    if (Object.keys(zodLocales).includes(language)) {
        // TypeScript fix: ensure language is a valid key of z.locales
        const lang = language as Language
        const defaultZodError = z.locales[lang]?.().localeError

        if (defaultZodError) {
            z.config({
                localeError: defaultZodError,
            })
        }
    }
}
